import { WykonawcaZespolu } from "./wykonawcaZespolu";

export class SzczegolyZespolu {
    id: string;
    nazwa: string;
    idWykonawcow: Array<string> = new Array();
    projektId: string;
}